import React from 'react'

function ClearFilterBtn() {
  return (
    <div>ClearFilterBtn</div>
  )
}

export default ClearFilterBtn